import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';


export enum ThemeMode {
  DARK, LIGHT
}

@Injectable({
  providedIn: "root"
})
export class UiStyleToggleServiceService {

  private readonly THEME_KEY = 'THEME';
  private readonly DARK_THEME_VALUE = 'DARK';
  private readonly LIGHT_THEME_VALUE = 'LIGHT';
  private readonly DARK_THEME_CLASS_NAME = 'dark-theme';
  private readonly LIGHT_THEME_CLASS_NAME = 'light-theme';

  private darkThemeSelected = false;
  public theme$ = new BehaviorSubject<ThemeMode>(ThemeMode.LIGHT);


  constructor() {
    document.body.classList.add(this.LIGHT_THEME_CLASS_NAME);
  }


  public setThemeOnStart() {

    if (this.isDarkThemeSelected) {
      this.setDarkTheme();
    } else {
      this.setLightTheme();
    }

    setTimeout(() => {
      document.body.classList.add('animate-color-transition');
    }, 500);

  }


  public toggle() {

    if (this.isDarkThemeSelected()) {
      this.setLightTheme();
      localStorage.setItem('Thememode','light')
   //   this.componentMethodCallSource.next();

    } else {
      this.setDarkTheme();
      localStorage.setItem('Thememode','dark')
    //  this.componentMethodCallSource.next();

    }

  }

  private isDarkThemeSelected() {
    return this.darkThemeSelected;
  }
  private componentMethodCallSource = new Subject<any>();
  componentMethodCalled$ = this.componentMethodCallSource.asObservable();

  private setLightTheme() {

    document.body.classList.remove(this.DARK_THEME_CLASS_NAME);
    this.darkThemeSelected = false;
    this.theme$.next(ThemeMode.LIGHT);

  }

  private setDarkTheme() {
    document.body.classList.add(this.DARK_THEME_CLASS_NAME);
    this.darkThemeSelected = true;
    this.theme$.next(ThemeMode.DARK);

  }


}